import { Swiper, SwiperSlide } from "swiper/react";
import style from "./desktopSlider.module.scss";
import { Product } from "../../../../models/home-rows";
import Prev from "../../../../../shared-assets/Svg/PrevArrow.svg";
import Next from "../../../../../shared-assets/Svg/NextArrow.svg";
import { useRef, useState } from "react";

import { DesktopSliderCard } from "./desktopSliderCard";
type SwiperProps = {
  products: Product[];
};
type SwiperState = "START" | "BETWEEN" | "END";
const DesktopSlider = ({ products }: SwiperProps) => {
  const swiperRef = useRef(null);
  const [swiperState, setSwiperState] = useState<SwiperState>("START");
  const breakpoints = {
    1200: {
      spaceBetween: 32
    },
    1000: {
      spaceBetween: 24
    },
    769: {
      spaceBetween: 16
    }
  };

  return (
    <Swiper
      onSwiper={swiper => (swiperRef.current = swiper)}
      className={style.swiper}
      slidesPerView={4.5}
      slidesPerGroup={4}
      dir="rtl"
      // loop={true}
      breakpoints={breakpoints}
      onSlideChange={swiper => {
        swiper.isBeginning
          ? setSwiperState("START")
          : swiper.isEnd
          ? setSwiperState("END")
          : setSwiperState("BETWEEN");
      }}
    >
      {swiperState !== "END" && (
        <div className={style.buttonNextWrapper}>
          <span
            className={style.buttonNext}
            onClick={() => swiperRef?.current?.slideNext()}
          >
            <Next width={"100%"} height={"100%"} />
          </span>
        </div>
      )}

      {!!products &&
        products.length > 0 &&
        products.map((product, index) => (
          <SwiperSlide key={"swip-prod-" + product?.id} virtualIndex={index}>
            <DesktopSliderCard product={product} />
          </SwiperSlide>
        ))}

      {swiperState !== "START" && (
        <div className={style.buttonPrevWrapper}>
          <span
            className={style.buttonNext}
            onClick={() => swiperRef?.current?.slidePrev()}
          >
            <Prev width={"100%"} height={"100%"} />
          </span>
        </div>
      )}
    </Swiper>
  );
};

export default DesktopSlider;
